'use client';
import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import type { InspectWizardState } from './InspectWizardClient';

interface Props {
  state: InspectWizardState;
  onChange: (u: Partial<InspectWizardState>) => void;
  onBack: () => void;
  onNext: () => void;
}

export default function InspectStepDimensions({ state, onChange, onBack, onNext }: Props) {
  const [errors, setErrors] = useState<Record<string, string>>({});

  const length = parseFloat(state.length) || 0;
  const width = parseFloat(state.width) || 0;
  const area = length * width;

  const validate = () => {
    const errs: Record<string, string> = {};
    if (!state.length || parseFloat(state.length) <= 0) errs.length = 'يجب إدخال قيمة أكبر من صفر';
    if (!state.width || parseFloat(state.width) <= 0) errs.width = 'يجب إدخال قيمة أكبر من صفر';
    if (!state.ceilingHeight || parseFloat(state.ceilingHeight) <= 0) errs.ch = 'يجب إدخال ارتفاع السقف';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const inputClass = (field: string) =>
    `w-full px-4 py-3 rounded-xl border-2 bg-card text-foreground font-tabular text-base focus:outline-none focus:border-secondary transition-all ${
      errors[field] ? 'border-danger' : 'border-border'
    }`;

  return (
    <div className="slide-up">
      <div className="text-center mb-8">
        <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-2">
          ما أبعاد {state.roomType?.nameAr}؟
        </h2>
        <p className="text-muted-foreground">أدخل أبعاد المكان بالمتر</p>
      </div>

      <div className="wizard-card p-6 lg:p-8 max-w-2xl mx-auto">
        {area > 0 && (
          <div className="bg-gray-50 rounded-xl p-4 mb-6 flex items-center justify-between fade-in border border-secondary/10">
            <span className="text-secondary font-semibold">مساحة المكان المحسوبة</span>
            <span className="text-2xl font-bold text-secondary font-tabular">{area.toFixed(1)} m²</span>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-semibold text-foreground mb-1">الطول <span className="text-danger">*</span></label>
            <p className="text-xs text-muted-foreground mb-2">بالمتر</p>
            <input type="number" min="0.1" max="500" step="0.1" placeholder="5.0"
              value={state.length} onChange={(e) => onChange({ length: e.target.value })}
              className={inputClass('length')} />
            {errors.length && <p className="text-danger text-xs mt-1">{errors.length}</p>}
          </div>

          <div>
            <label className="block text-sm font-semibold text-foreground mb-1">العرض <span className="text-danger">*</span></label>
            <p className="text-xs text-muted-foreground mb-2">بالمتر</p>
            <input type="number" min="0.1" max="500" step="0.1" placeholder="4.0"
              value={state.width} onChange={(e) => onChange({ width: e.target.value })}
              className={inputClass('width')} />
            {errors.width && <p className="text-danger text-xs mt-1">{errors.width}</p>}
          </div>

          <div>
            <label className="block text-sm font-semibold text-foreground mb-1">ارتفاع السقف <span className="text-danger">*</span></label>
            <p className="text-xs text-muted-foreground mb-2">بالمتر</p>
            <input type="number" min="1.5" max="20" step="0.1" placeholder="2.8"
              value={state.ceilingHeight} onChange={(e) => onChange({ ceilingHeight: e.target.value })}
              className={inputClass('ch')} />
            {errors.ch && <p className="text-danger text-xs mt-1">{errors.ch}</p>}
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-8 max-w-2xl mx-auto">
        <button onClick={onBack} className="btn-secondary px-6 py-3 rounded-xl flex items-center gap-2">
          <ArrowRight size={18} />
          <span>السابق</span>
        </button>
        <button onClick={() => { if (validate()) onNext(); }}
          className="px-8 py-3 rounded-xl font-bold text-white flex items-center gap-2 transition-all gradient-dark hover:opacity-90">
          <span>التالي</span>
          <ArrowLeft size={18} />
        </button>
      </div>
    </div>
  );}